import autoScroll from './functions/_autoScroll.js' // 自動スクロール
if (document.getElementById('page-release')) {
  page()
}

function page() {
  /*
     ###          ##    ###    ##     ##
   ##   ##        ##  ##   ##    ## ##
  ##     ##       ## ##     ##    ###
  ######### ##    ## #########   ## ##
  ##     ##  ######  ##     ## ##     ##
  */
  let ajax = false // Ajaxリクエスト
  let ajaxResponse = '' // 最後のレスポンスを格納する

  /*
          ##       #### ##    ## ##    ##
          ##        ##  ####  ## ##  ##
  ####### ##        ##  ## ## ## #####
          ##        ##  ##  #### ##  ##
          ######## #### ##    ## ##    ##

  Aタグのリンク先と通信する
  <a href="<?php echo termLink; ?>" class="js-linkAjax" data-from="#a" data-to="#a" data-push="on">

  </a>
  */

  window.addEventListener('click', (e) => {
    const item = e.target.closest('.js-linkAjax')
    if (!item) {
      return
    }
    e.preventDefault()
    const url = item.attributes['href'].value // 取得先
    const type = item.dataset.type // add(追加)もしくはrep(差し替え)
    const from = item.dataset.from // 取得要素
    const to = item.dataset.to // 差し替え要素
    const pushSt = item.dataset.push // URLのプッシュ
    const scroll = item.dataset.scroll // スクロール先
    const flag = item.dataset.flag // 追加の処理フラグ
    applyAjax(url, 'GET', null, from, to, pushSt, type, scroll, flag)
  })

  //            ##       #####     ###    ####
  //            ##      ##   ##   ## ##   ##  ##
  //  ########  ##      ##   ##  ##   ##  ##  ##
  //            ##      ##   ##  #######  ##  ##
  //            ######   #####   ##   ##  ####
  /*
  ページアクセス時にロードする
  <div id="js-loadAjax" data-url="" data-from="" data-to=""></div>
  */
  const loadAjax = document.getElementById('js-loadAjax')
  if (loadAjax) {
    const item = loadAjax
    const url = item.dataset.url // 取得先
    const from = item.dataset.from // 取得要素
    const to = item.dataset.to // 差し替え要素
    applyAjax(url, 'GET', null, from, to, false, 'rep', false)
  }

  const loadAjaxAdd = document.getElementById('js-loadAjax-add')
  if (loadAjaxAdd) {
    const item = loadAjaxAdd
    const url = item.dataset.url // 取得先
    const from = item.dataset.from // 取得要素
    const to = item.dataset.to // 差し替え要素

    // GETパラメータ取得
    const params = new URL(document.location).searchParams
    const getID = params.get('id')

    applyAjax(url + getID + '/', 'GET', null, from, to, false, 'rep', false, 'updateMeta')
  }

  /*
          ########     ###     ######  ##    ##
          ##     ##  ##   ##  ##       ##  ##
  ####### ########  ##     ## ##       #####
          ##     ## ######### ##       ##  ##
          ########  ##     ##  ######  ##    ##

  ブラウザバックでのアクセス時にURL通りのものをロードする
  <div id="js-backAjax" data-from="#a" data-to="#a"></div>
  */
  const backAjax = document.getElementById('js-backAjax')
  if (backAjax) {
    if (window.history && window.history.pushState) {
      window.onpopstate = function (e) {
        const item = backAjax
        const url = location.href // 取得先
        const from = item.dataset.from // 取得要素
        const to = item.dataset.to // 差し替え要素
        applyAjax(url, 'GET', null, from, to, false, 'rep', false)
      }
    }
  }

  /*
        #### ##    ## ########  ##     ## ########
         ##  ####  ## ##     ## ##     ##    ##
#######  ##  ## ## ## ########  ##     ##    ##
         ##  ##  #### ##        ##     ##    ##
        #### ##    ## ##         #######     ##

テキスト入力時に通信する
<input id="" class="js-textAjax" type="text" name="" placeholder="" data-url="<?php echo H_URL; ?>" data-from="#a" data-to="#a" data-push="on">
*/
  let ajaxWord = ''
  window.addEventListener('input', (e) => {
    if (e.target.classList.contains('js-textAjax')) {
      e.preventDefault()
      const item = e.target
      if (item.classList.contains('reset')) {
        item.classList.remove('reset')
      } else if (ajaxWord === item.value) {
        // キーワードが変わっていなければ処理しない
        return false
      }
      ajaxWord = item.value
      const url = item.dataset.url + encodeURI(ajaxWord) // 取得先
      const type = item.dataset.type // add(追加)もしくはrep(差し替え)
      const from = item.dataset.from // 取得要素
      const to = item.dataset.to // 差し替え要素
      const pushSt = item.dataset.push // URLのプッシュ
      const scroll = item.dataset.scroll // スクロール先
      applyAjax(url, 'GET', null, from, to, pushSt, type, scroll)
    }
  })

  //             ####  #####  ##      #####   ####  ######
  //            ##     ##     ##      ##     ##       ##
  //  ########   ###   #####  ##      #####  ##       ##
  //               ##  ##     ##      ##     ##       ##
  //            ####   #####  ######  #####   ####    ##
  /*
セレクトボックスの切替時、data-linkのURLに通信する
<select name="" class="js-selectAjax" data-from="#a" data-to="#a" data-push="on">
    <option value="" data-link="https://example.com">最新順</option>
</select>
*/
  window.addEventListener('change', (e) => {
    if (e.target.classList.contains('js-selectAjax')) {
      e.preventDefault()
      const item = e.target
      const url = item.querySelector('option:checked').dataset.link // 取得先
      const type = item.dataset.type // add(追加)もしくはrep(差し替え)
      const from = item.dataset.from // 取得要素
      const to = item.dataset.to // 差し替え要素
      const pushSt = item.dataset.push // URLのプッシュ
      const scroll = item.dataset.scroll // スクロール先
      window.applyAjax(url, 'GET', null, from, to, pushSt, type, scroll)
    }
  })

  /*
           ########  #######  ########  ##     ##
           ##       ##     ## ##     ## #### ####
   ####### ######   ##     ## ########  ## ### ##
           ##       ##     ## ##   ##   ##     ##
           ##        #######  ##     ## ##     ##

  フォーム送信して結果を反映する
  buttonのdata-form属性と同じnameのform内の入力を取得、formaction属性のURLに送信する

  <form action="hoge.php" method="POST" name="form-name">
    <button type="button" formaction="hoge.php"  class="js-contactAjax" data-form="form-name" data-from="#list" data-to="#list" data-push="on">
        更新
    </button>
  </form>

  */

  window.addEventListener('input', (e) => {
    if (e.target.classList.contains('js-contactAjax')) {
      e.preventDefault()
      ajaxSubmit(e.target)
    }
  })

  function ajaxSubmit(item) {
    let param = '' // 送信パラメータ
    const name = item.dataset.form
    const form = document.forms[name] // 指定nameのformに存在するinputにアクセス
    const url = form.action // 取得先

    const method = form.method // GET/POST

    const type = item.dataset.type // add(追加)もしくはrep(差し替え)
    const from = item.dataset.from // 取得要素
    const to = item.dataset.to // 差し替え要素
    const pushSt = item.dataset.push // URLのプッシュ
    const scroll = item.dataset.scroll // スクロール先

    // if (item.name && item.value) {
    //   // クリックしたボタンの値を取り込む
    //   param += item.name + '=' + encodeURIComponent(item.value)
    // }

    // 指定されているinputを取得して送信データ化する
    const inputList = form.querySelectorAll('input,textarea,select')

    for (const input of inputList) {
      if ((input.type === 'checkbox' || input.type === 'radio') && !input.checked) {
        // 未チェックのチェックは飛ばす
        continue
      }
      if (param !== '') {
        param += '&'
      }
      param += input.name + '=' + encodeURIComponent(input.value)
    }

    // console.log(param)
    applyAjax(url, method, param, from, to, pushSt, type, scroll)
  }

  /*
             ###    ########  ########  ##       ##    ##
           ##   ##  ##     ## ##     ## ##         ####
  ####### ##     ## ########  ########  ##          ##
          ######### ##        ##        ##          ##
          ##     ## ##        ##        ########    ##
  */
  /**
   * Ajaxで取得したHTMLドキュメントの head から、タイトル・description・OGP/Twitter を現在ページへ反映する
   * @param {Document} ajaxDoc
   */
  function updateHeadMetaFromAjaxResponse(ajaxDoc) {
    if (!ajaxDoc || !ajaxDoc.head) {
      return
    }

    const titleSrc = ajaxDoc.querySelector('title')
    if (titleSrc) {
      const text = titleSrc.textContent.trim()
      document.title = text
      const titleEl = document.querySelector('title')
      if (titleEl) {
        titleEl.textContent = text
      }
    }

    const srcMetas = ajaxDoc.head.querySelectorAll('meta[name], meta[property]')
    srcMetas.forEach((src) => {
      const name = src.getAttribute('name')
      const property = src.getAttribute('property')
      if (!src.hasAttribute('content')) {
        return
      }

      // og:url は WordPress 側のURLになるため、後段で現在ページURLを入れる
      if (property === 'og:url') {
        return
      }

      const syncDescription = name === 'description'
      const syncOg = property && property.indexOf('og:') === 0
      const syncTwitter = name && name.indexOf('twitter:') === 0
      if (!syncDescription && !syncOg && !syncTwitter) {
        return
      }

      let dst = null
      if (property) {
        dst = document.head.querySelector(`meta[property="${property}"]`)
      } else if (name) {
        dst = document.head.querySelector(`meta[name="${name}"]`)
      }

      const content = src.getAttribute('content')
      if (dst) {
        dst.setAttribute('content', content)
      } else {
        try {
          document.head.appendChild(document.importNode(src, true))
        } catch (e) {
          /* ignore */
        }
      }
    })

    const pageUrl = window.location.href.split('#')[0]
    let ogUrlEl = document.head.querySelector('meta[property="og:url"]')
    if (ogUrlEl) {
      ogUrlEl.setAttribute('content', pageUrl)
    } else {
      ogUrlEl = document.createElement('meta')
      ogUrlEl.setAttribute('property', 'og:url')
      ogUrlEl.setAttribute('content', pageUrl)
      document.head.appendChild(ogUrlEl)
    }
  }

  /**
   * Ajax処理を実行する
   * @param url {string} 取得先のURL
   * @param from {string} 書き換え元のセレクタ　,区切りで複数指定
   * @param to {string} 取得先のセレクタ　,区切りで複数指定
   * @param pushSt {string|boolean} 擬似的にページ遷移する　falseじゃなければ有効
   * @param type {string} rep:要素を書き換える add:書き換え元の下に追加する
   * @param scroll {string} 指定の位置にスクロールさせる
   * @param flag {string} 独自の拡張用
   */
  function applyAjax(url, method = 'get', param, from, to, pushSt, type = 'rep', scroll = false, flag = null) {
    from = from.split(',') // ,区切りで配列に変換
    to = to.split(',') // ,区切りで配列に変換

    /** #js-loadAjax-add（flag=updateMeta）のみ：取得失敗時に1階層上へ離脱 */
    const exitToParentOnLoadAjaxAddFail = flag === 'updateMeta'
    function redirectLoadAjaxAddToParent() {
      if (!exitToParentOnLoadAjaxAddFail) {
        return
      }
      window.location.href = new URL('../', window.location.href).href
    }

    const loadingItem = document.createElement('div')
    loadingItem.className = 'mdLoading active'

    // ローディング処理
    for (let index = 0; index < to.length; index++) {
      const itemTo = document.querySelector(to[index])
      const loadingItem = document.createElement('div')
      loadingItem.className = 'mdLoading active'
      if (type === 'rep') {
        loadingItem.style.width = itemTo.offsetWidth + 'px'
        loadingItem.style.height = itemTo.offsetHeight + 'px'
        itemTo.innerHTML = ''
      }
      itemTo.appendChild(loadingItem)
    }

    if (ajax) {
      // 既に通信中なら切断
      ajax.abort()
    }

    ajax = new XMLHttpRequest() // Ajaxリクエスト
    if (method === 'post') {
      ajax.open(method, url, true) // GET/POST, URL, 非同期処理
    } else {
      if (param) {
        console.log(url)

        url += (~url.indexOf('?') ? '&' : '?') + param // パラメータをURLに結合
      }
      if (pushSt === 'on') {
        history.pushState(null, null, url) // URL変更
      }
      // Ajaxと明示するパラメータを付ける
      url += (~url.indexOf('?') ? '&' : '?') + 'ajax=1'
      ajax.open(method, url, true) // GET/POST, URL, 非同期処理
    }
    ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest') // Ajaxでのアクセスと明示するリクエストヘッダー
    // キャッシュせず最新のデータを取る場合のリクエストヘッダー3種
    // ajax.setRequestHeader('Pragma', 'no-cache')
    // ajax.setRequestHeader('Cache-Control', 'no-cache')
    // ajax.setRequestHeader('If-Modified-Since', 'Thu, 01 Jun 1970 00:00:00 GMT')
    if (method === 'post') {
      ajax.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded') // POST時に必要なリクエストヘッダー
    }
    ajax.responseType = 'document' // 取得タイプ document text json
    ajax.timeout = 10000 // タイムアウト判定時間
    if (method === 'post') {
      ajax.send(param) // POSTリクエスト実行
    } else {
      ajax.send() // GETリクエスト実行
    }
    ajax.onload = function () {
      // アクセス成功
      if (ajax.status < 200 || ajax.status >= 400) {
        console.log('Error: Code ' + ajax.status) // エラー
        redirectLoadAjaxAddToParent()
        return
      }

      if (ajax.response === ajaxResponse) {
        // 前と結果が同じなら何もしない
        return
      }
      ajaxResponse = ajax.response // 取得結果を更新

      let ajaxData = ajaxResponse // 実際に使用するデータ

      // // IEは取得タイプJSONをtextで受け取るのでJSONにパースする
      // if (navigator.userAgent.indexOf('Trident') !== -1 && JSON) {
      //   ajaxData = JSON.parse(ajaxData)
      // }
      for (let index = 0; index < to.length; index++) {
        const itemFrom = ajaxData.querySelector(from[index])
        const itemTo = document.querySelector(to[index])

        if (!itemFrom || !itemTo) {
          console.log('Error: Ajax response or target element missing')
          redirectLoadAjaxAddToParent()
          return
        }

        if (type === 'rep') {
          itemTo.innerHTML = itemFrom.innerHTML
        } else {
          // addなら既存の要素を消さずに追加
          const delLoading = itemTo.querySelector('.mdLoading')
          delLoading.parentNode.removeChild(delLoading)
          itemTo.innerHTML += itemFrom.innerHTML
        }
        // intObs()

        if (scroll) {
          autoScroll(scroll, 0, true)
        }
      }

      if (pushSt === 'on' || flag === 'updateMeta') {
        updateHeadMetaFromAjaxResponse(ajaxData)
      }
    }
    ajax.ontimeout = function (e) {
      redirectLoadAjaxAddToParent()
    }
    ajax.onerror = function () {
      redirectLoadAjaxAddToParent()
    }
    ajax.onloadend = function () {
      // 受信成否に関わらず実行
      // intObsAjax()
      ajax = false
    }
  }
}
